import styled from '@emotion/styled';
import { Avatar } from '@mui/material';
import { COLOR_VARIANTS, color, Tooltip } from '@tajawal/ct-web-design-system';
import { Z_INDEX_LAYERS } from '@/constants/style.constants';
import { shouldForwardProp } from '@/utils/style.utils';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: 80px;
`;

const AirlineLogoInTooltip = styled.div`
  width: 40px;
  height: 40px;
  margin-left: -6px;
  z-index: ${Z_INDEX_LAYERS.TOOLTIP_LAYER};
`;

const MarketingAirlineLogo = styled(Avatar)`
  margin-left: -6px;
  z-index: ${Z_INDEX_LAYERS.TOOLTIP_LAYER};
`;

const AirlineLogoPlus = styled.div`
  border-radius: 50%;
  outline: 2px solid ${color(COLOR_VARIANTS.WHITE)};
  transform: translateX(-5px);
  z-index: ${Z_INDEX_LAYERS.OVERLAY_LAYER};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  border: 1px solid ${color(COLOR_VARIANTS.GAINSBORO)};
`;

const AirlineLogosWrapper = styled.div`
  display: flex;
  align-self: center;
  .MuiAvatar-root:last-child:not(:first-child) {
    transform: translateX(-10px);
    z-index: ${Z_INDEX_LAYERS.TOOLTIP_LAYER};
  }
`;

const AirlineLogo = styled(Avatar, { shouldForwardProp })<{ $isFlightDetails?: boolean }>`
  outline: 2px solid ${color(COLOR_VARIANTS.WHITE)};
  border: 0.5px solid ${color(COLOR_VARIANTS.GAINSBORO)};
  background-color: ${color(COLOR_VARIANTS.WHITE)};
`;

const TooltipWrapper = styled(Tooltip)`
  display: flex;
  align-items: center;
  width: 70px;
`;

export default {
  Wrapper,
  AirlineLogo,
  MarketingAirlineLogo,
  AirlineLogosWrapper,
  AirlineLogoPlus,
  AirlineLogoInTooltip,
  TooltipWrapper,
};
